import { ref } from 'vue';

export default () => {
  const drawerOpen = ref(false);
  const back = ref('/home');
  const showAppbar = ref(false);
  const navbarText = ref('');
  const loading = ref(false);
  const loadingMessage = ref('');
  const selectedFarmId = ref(0);
  const filters = ref({ pregnantOverdue: false });

  return {
    state: {
      drawerOpen,
      back,
      showAppbar,
      navbarText,
      loading,
      loadingMessage,
      selectedFarmId,
      filters
    },
    funcs: {}
  };
};
